<template>
  <div class="main_head">
    <div v-if="$store.state.user.userInfo.isWenwu" class="main_head_logo center" style="width:18%">
      <img src="@/assets/img/logo1.png" style="width: 22px; height: 32px" />
      <span style="font-size:15px">青岛八大关近代建筑预防性保护平台</span>
      <!-- <span v-else>同人消防物联网监控平台</span> -->
    </div>

    <div v-else class="main_head_logo center">
      <img src="@/assets/img/logo1.png" style="width: 24px; height: 34px" />
      <span>同人智慧消防综合管理平台</span>
      <!-- <span v-else>同人消防物联网监控平台</span> -->
    </div>

    <div class="main_end">
      <ul class="main_navigation_bar align-center inline-hide">
        <li class="tnav">
          <router-link to="/"> 首页</router-link>
        </li>
        201
        <li class="tnav" v-for="nav in permission.addRoutes" v-if="nav.meta && nav.meta.title">
          <router-link :to="''" tag="a">{{ nav.meta ? nav.meta.title : '' }}</router-link>
          <i class="fa fa-angle-down" v-if="nav.children && nav.children.length"></i>
          <ul class="main_navigation_shu_bar">
            <router-link tag="li" :to="{ path: `${child.path}`, query: child.outline ? { url: child.outline } : null }" v-for="child in nav.children"
              >{{ child.meta.title }}
            </router-link>
          </ul>
        </li>
        <li class="tnav" v-if="$store.state.isDev">
          <router-link :to="'/'" tag="a"> devlop</router-link>
          <i class="fa fa-angle-down"></i>
          <ul class="main_navigation_shu_bar">
            <router-link tag="li" to="/makeForm">makeForm</router-link>
            <li @click="weihuAdd = true">维护时间</li>
          </ul>
        </li>
      </ul>

      <div class="main_user_weather">
        <div class="main_clock_weather">
          <!-- <div class="main_clock" v-if="nowTime">
            <div class="time">{{ nowTime.split(" ")[1] }}</div>
            <div class="date">{{ nowTime.split(" ")[0] }}</div>
          </div> -->
          <div class="main_weather" v-if="weather.temperature">
            <div class="weather">
              <i :class="'wi wi-' + weatherIcon"></i>
            </div>
            <div class="wd">
              <div class="ssd">{{ weather.temperature }}℃</div>
              <div class="tq">
                {{ weather.weather }}
              </div>
            </div>
            <div class="wind">
              <div class="w-x">
                <i :class="'wi wi-wind wi-towards-' + winddirectionIcon"></i>
              </div>
              <div class="w-level">{{ weather.winddirection }}风{{ weather.windpower }}级</div>
            </div>
          </div>
        </div>
        <div class="main_user_zoom">
          <el-dropdown @command="select">
            <div class="head-user">
              <div class="head-user-img">
                <img src="@/assets/img/default-head.png" />
              </div>
              <div class="head-user-role">
                <!-- {{
                  $store.state.userInfo.username ||
                  $store.state.userInfo.company_num
                }} -->
                {{ $store.state.user.userInfo.nickName }}
                <i class="fa fa fa-caret-down"></i>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <template>
                <!-- <el-dropdown-item command="linkto">访问官网</el-dropdown-item> -->
                <!-- <el-dropdown-item>用户交接</el-dropdown-item> -->
                <el-dropdown-item command="accBind">账号绑定</el-dropdown-item>
              </template>
              <!--<el-dropdown-item>个人中心</el-dropdown-item>-->
              <el-dropdown-item command="changePass">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 
          <div class="head-zoom c-f">
            <i
              class="icon-tr-maximization"
              v-show="!isFullScreen"
              @click="FullScreen"
            ></i>
            <i
              class="icon-tr-minimize"
              v-show="isFullScreen"
              @click="noFullScreen"
            ></i>
          </div> -->
          <el-dialog :visible.sync="weihuAdd" width="30%" :show-close="true" v-if="$store.state.isDev" style="z-index: 999  !important;">
            <el-form v-model="weihufm">
              <el-date-picker v-model="weihufm.starttime" type="datetime" placeholder="" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
              <el-date-picker class="mt20" v-model="weihufm.endtime" type="datetime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
            </el-form>
            <div class="center mt20">
              <el-button type="primary" @click="weihu">保存</el-button>
            </div>
          </el-dialog>

          <el-dialog title="修改密码" :visible.sync="showDia" width="500px" :append-to-body="true" :close-on-click-modal="false">
            <el-form ref="passForm" :model="passForm" label-width="110px" :rules="rules">
              <!-- <el-form-item label="请输入旧密码" prop="old">
                    <el-input placeholder="请输入旧密码" v-model="passForm.old" show-password></el-input>
                </el-form-item> -->
              <el-form-item label="请输入旧密码" prop="old_password">
                <el-input placeholder="请输入旧密码" v-model="passForm.old_pwd" show-password></el-input>
              </el-form-item>
              <el-form-item label="请输入新密码" prop="new_password">
                <el-input placeholder="请输入新密码" v-model="passForm.new_pwd" show-password></el-input>
              </el-form-item>
              <el-form-item label="请确认密码" prop="new_confirm">
                <el-input placeholder="请确认密码" v-model="passForm.confirm" show-password></el-input>
              </el-form-item>
            </el-form>
            <div class="center mt20">
              <el-button type="primary" @click="passSubmit" size="small">提交</el-button>
              <el-button @click="resetchange(true)" size="small">取消</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { LatheGeometry } from 'three';
import { getTime, getWeather, logout, getMenu } from '../api/common.js';
import Crypto from '../utils/crypto';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['permission', 'isWaring']),
  },
  data() {
    return {
      navList: [],
      showDia: false,
      allList: [],
      loading: true,
      menuList: [],
      // outLineList:[{fa_menu_name:'基础设置',menu_name:'执法记录',out_href:"aaa"}], // 外部链接
      isFullScreen: false,
      nowTime: '',
      weather: {},
      rules: {},
      timer: null,
      passForm: {
        old_pwd: '',
        new_pwd: '',
        confirm: '',
      },
      weatherIcon: '',
      winddirectionIcon: '',
      weihuAdd: false,
      weihufm: {
        starttime: '',
        endtime: '',
      },
    };
  },
  mounted() {
    // {{ $store.state.user.userInfo.tongxin }}
    this.setTime();
    this.setWeather();
    // setTimeout(() => {
    // }, 4000);
    // this.getMenu();
    setInterval(this.setWeather, 3 * 60 * 60 * 1000); //3小时更新一次天气
  },
  watch: {
    '$route.path'(val, old) {
      // console.log( )

      this.checkRouter(val);
    },
    'permission.addRoutes'(val) {},
    // "$store.state.userInfo.region": {
    //   handler(val, oldVal) {
    //     console.log(11111111111111111111111111, val);
    //     this.setWeather();
    //   },
    //   immediate: true,
    //   deep: true,
    // },

    '$store.state.user.userInfo.region': {
      deep: true,
      handler(val) {
        log(val, 1111);
      },
      immediate: true,
      // immediate: true,
      // handler: function(newval) {
      //   log(newval, "更新天气");
      //   this.setWeather(newval);
      // },
      // deep: true,
    },
  },
  computed: {},
  methods: {
    changePass() {
      this.showDia = true;
    },
    passSubmit() {
      console.log(this.passForm);
      var { old_pwd, new_pwd, confirm } = this.passForm;
      if (!old_pwd || !new_pwd || !confirm) {
        this.$message.error('请填写必填信息');
        return false;
      } else if (confirm !== new_pwd) {
        this.$message.error('输入的两次密码不相同');
        return false;
      } else if (old_pwd === new_pwd) {
        this.$message.error('新密码不可以与旧密码相同');
        return false;
      }

      this.$post('/user/xiugaimima', this.passForm).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
        this.resetchange();
        this.showDia = false;
        setTimeout(() => {
          this.$store.commit('clearUser');

          this.$router.replace({
            path: '/login',
          });
        }, 1400);
      });
    },
    resetchange(a) {
      this.passForm = { old_pwd: '', new_pwd: '', confirm: '' };
      if (a) {
        this.showDia = false;
      }
    },

    chaneNum(v) {
      var str = Number(v) <= 9 ? `0${v}` : v;
      return str;
    },
    weihu() {
      this.$post('/role/addmaintain', this.weihufm).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
      });
    },
    select(val) {
      this[val]();
    },
    // logout() {
    //   logout({ token: this.$store.state.token }).then((res) => {
    //     this.$store.commit("clearUser");

    //     this.$router.replace({
    //       path: "/login",
    //     });
    //   });
    // },
    async logout() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.replace({
            path: '/login',
          });
        });
      });
    },
    linkto() {
      // var date = new Date();
      // var time = `${date.getFullYear()}-${this.chaneNum(date.getMonth() + 1)}-${date.getDate()}`;
      // var obj = { user: this.$local.get("account").username, time };
      // this.$post("/website/automaticlogin", obj).then((res) => {
      //   window.open(`http://www.tongren119.com?info=${res}`, "_blank");
      // });
      window.open('https://www.tongren119.com/');
    },
    // 账号绑定
    accBind() {},
    getMenu() {
      this.$post('/menu/thisusermenu').then((res) => {
        this.navList = res.data;
        for (let key in this.navList) {
          this.menuList.push(this.navList[key].menu_href);

          if (this.navList[key].menu_name == '基础设置' && this.$store.state.user.company.cCompanyNum === 'aaa') {
            this.navList[key].tr_power_hson.push(
              {
                menu_name: '执法记录',
                menu_href: 'webview',
                outline: 'https://trtest.tongren119.com/#/login?YXV0b2xvZ2luPTEmdHlwZT0y',
              },
              {
                menu_name: '消防预案',
                menu_href: 'webview',
                outline: 'https://www.anfangxing.cn/shandong/index.html#!/commanding/a15cdf66-00e0-4dbe-8d6f-654d9d7caa66/a1b3b4d1-c0d8-49c3-9b07-dde379ea09a1',
              },
            );
          }

          if (this.navList[key].tr_power_hson) {
            this.navList[key].tr_power_hson.forEach((menu) => {
              this.menuList.push(menu.menu_href);
            });
          }
        }
      });
      this.$post('/menu/findall', { page: 1, limit: 100 }).then((res) => {
        // console.log(res.data)
        let arr = res.data.list;
        for (let key in arr) {
          this.allList.push(arr[key].menu_href);
        }
        this.checkRouter(this.$route.path);
      });
    },
    outline(it) {
      // if(it.outline){
      //   window.location.href = it.outline
      // }
    },
    setTime() {
      // getTime().then((data) => {
      // let time = data.sysTime2.replace(/-/g, "/");
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace('T', ' ')
        .replace(/-/g, '/');

      let timeLine = new Date(time).getTime();
      this.nowTime = new Date(timeLine).Format('yy年MM月dd日 hh:mm:ss');
      this.$local.save('nowtime', this.nowTime);

      this.timer = setInterval(() => {
        timeLine += 1000;
        this.nowTime = new Date(timeLine).Format('yy年MM月dd日 hh:mm:ss');
        this.$local.save('nowtime', this.nowTime);
      }, 1000);
      // });
    },
    setWeather() {
      let code = 370200;
      if (this.$store.state.userInfo.region == 2) {
        code = 370100;
      }
      getWeather({
        key: 'c2033986fe11749475852e35030fe835',
        city: code,
        extensions: 'base',
      }).then((data) => {
        console.log(data,666666666666);
        this.weather = data.lives[0];
        this.weatherIcon = this.getweatherName(this.weather.weather);
        this.winddirectionIcon = this.getwind(this.weather.winddirection);
      });
    },
    checkRouter(val) {
      if (this.$store.state.isDev) {
        return;
      }
      setTimeout(() => {
        if (this.menuList.indexOf(val.substr(1)) === -1 && this.allList.indexOf(val.substr(1)) > -1) {
          if (this.$route.path !== '/404' && this.$route.path !== '/') {
            this.$router.replace('/404');
          }
        }
      }, 10);
    },
    getweatherName(text) {
      //获取天气ICON名
      var map = {
        雨: 'rain',
        晴: 'day-sunny',
        雪: 'snow',
        风: 'wind',
        云: 'cloudy',
        雾: 'fog',
        雷: 'thunderstorm',
        尘: 'day-haze',
        霾: 'day-haze',
        沙: 'day-haze',
      };
      for (var key in map) {
        if (text.indexOf(key) !== -1) {
          return map[key];
        }
      }
      return null;
    },
    getwind(text) {
      //获取风向
      var map = {
        东: 'e',
        南: 's',
        西: 'w',
        北: 'n',
      };
      var str = '';
      for (var key in text) {
        str += map[text[key]];
      }
      return str
        .split('')
        .reverse()
        .join('');
    },
    FullScreen() {
      var elem = document.body;
      if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullScreen();
        this.isFullScreen = true;
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
        this.isFullScreen = true;
      } else if (elem.requestFullScreen) {
        elem.requestFullscreen();
        this.isFullScreen = true;
      } else {
        this.$notify({
          title: '提示',
          message: '浏览器不支持全屏API或已被禁用',
        });
      }
    },
    noFullScreen() {
      var elem = document;
      if (elem.webkitCancelFullScreen) {
        elem.webkitCancelFullScreen();
        this.isFullScreen = false;
      } else if (elem.mozCancelFullScreen) {
        elem.mozCancelFullScreen();
        this.isFullScreen = false;
      } else if (elem.cancelFullScreen) {
        elem.cancelFullScreen();
        this.isFullScreen = false;
      } else if (elem.exitFullscreen) {
        elem.exitFullscreen();
        this.isFullScreen = false;
      } else {
        this.$notify({
          title: '提示',
          message: '浏览器不支持全屏API或已被禁用',
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tnav {
  z-index: 33;
  display: flex;
  align-items: center;
  height: 100%;
  .main_navigation_shu_bar {
    display: none;
  }

  i {
    margin-left: 5px;
  }

  &:hover {
    .main_navigation_shu_bar {
      display: block;
    }

    font-weight: 700;

    i,
    a {
      color: #fff;
    }
  }
}

.head-user {
  .main_navigation_shu_bar_manage {
    display: none;

    i {
      margin-right: 5px;
    }
  }

  &:hover {
    .main_navigation_shu_bar_manage {
      display: block;
    }
  }
}
.main_navigation_shu_bar > li {
  font-weight: 500;
}
.inline-hide {
}
.v-model {
  z-index: 500 !important;
}
</style>
